// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  serviceURL: "https://services.prod.zyla.in",
  apiURL: "https://api.zyla.in",
  name: "production",
  version: "v1.0.0",
  isExternalPwa: false,
  fcm_config: {
    apiKey: "AIzaSyDvCpz50pYwkg63zlD6iCodT75AGpqIhxc",
    authDomain: "zyla-dcf98.firebaseapp.com",
    databaseURL: "https://zyla-dcf98.firebaseio.com",
    projectId: "zyla-dcf98",
    storageBucket: "zyla-dcf98.appspot.com",
    messagingSenderId: "881703838584",
    appId: "1:881703838584:web:28cc6fcedb1f2d430a9e8d",
    measurementId: "G-KEBPQYSCJ6",
  },
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
